import { render } from "./Defaultwerte.vue?vue&type=template&id=0e6e2726"
import script from "./Defaultwerte.vue?vue&type=script&lang=js"
export * from "./Defaultwerte.vue?vue&type=script&lang=js"

import "./Defaultwerte.vue?vue&type=style&index=0&id=0e6e2726&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__